import { BAR, HORIZONTAL_STACKED, PIE } from "src/components/Charts/types";
import { GRADE_MULTIPLA, GRADE_UNICA } from "src/models/questionTypes";

const typeStrategies = [
  {
    name: HORIZONTAL_STACKED,
    matches: (pergunta) => [GRADE_UNICA, GRADE_MULTIPLA].includes(pergunta.tipo),
  },
  {
    name: PIE,
    matches: (pergunta) => pergunta.alternativas.length <= 6,
  },
  {
    name: BAR,
    matches: (pergunta) => pergunta.alternativas.length > 6,
  },
];

/**
 * Recupera o tipo do gráfico baseado na pergunta e resultados a serem renderizados.
 *
 * @param {*} pergunta contém o tipo e um array com os resultados a serem
 * renderizados em forma de chart.
 */
export function resolveChartType(pergunta) {
  const type = typeStrategies.find((type) => type.matches(pergunta));
  return type.name;
}
